const angular = require('angular');
import { consent } from '../consent/consent-bootstrap';
const app = angular.module('learn-services');

/**
 * Service for managing the Zendesk widget state
 * @argument {Application} Application defines the Application service
 */
app.factory('ZendeskWidget', ['Application', 'Authorization', '$interval', function (Application, Authorization, $interval) {
  var initialized = false;

  var load = function (callback) {
    if (!consent.accepted('functional')) {
      return;
    }
    if (!initialized) {
      initialized = true;
      window.zESettings = {
        webWidget: {
          contactForm: {
            attachments: true
          }
        }
      };
      var zdscript = document.createElement('script');
      zdscript.setAttribute('id', 'ze-snippet');
      zdscript.src = 'https://static.zdassets.com/ekr/snippet.js?key=' + Application.zdKey;
      (document.getElementsByTagName('body')[0]).appendChild(zdscript);
    }

    var zdonload = $interval(function () {
      if (typeof zE !== "undefined" && typeof zE.activate !== "undefined") {
        $interval.cancel(zdonload);

        zE('webWidget', 'hide');
        zE('webWidget:on', 'close', function () {
          zE('webWidget', 'hide');
        });

        // Initialize the widget styles and data.
        configure();

        if (callback) {
          callback();
        }
      }
    }, 50, null);
  };

  var configure = function () {
    var colorList = Application.colors.get();
    var brandColor = colorList ? colorList[0] : '#00BCF1';
    zE('webWidget', 'updateSettings', {
      webWidget: {
        color: {
          theme: brandColor,
          launcher: brandColor, // This will also update the badge
          launcherText: '#ffffff',
          button: brandColor,
          resultLists: brandColor,
          header: brandColor,
          articleLinks: brandColor
        }
      }
    });

    var company = Authorization.getAuthToken().company;
    var user = Authorization.getAuthToken().user;
    if (user.email) {
      // Zendesk settings
      zE('webWidget', 'identify', {
        name: user.first_name + ' ' + user.last_name,
        email: user.email,
        organization: company && company.name || 'n/a'
      });

      zE('webWidget', 'prefill', {
        name: {
          value: user.first_name + ' ' + user.last_name,
          readOnly: true
        },
        email: {
          value: user.email,
          readOnly: true
        },
        organization: {
          value: company && company.name || 'n/a',
          readOnly: true
        }
      });
    }
  };

  var display = function () {
    zE('webWidget', 'toggle');
    zE('webWidget', 'show');
  }

  return {
    load: load,
    configure: configure,
    display: display
  }
}]);
